// /get-started — the Join landing with the join (About you → Finish) module
// open. Rendered by the _landing layout (JoinLanding reads the path); this route
// only owns the path.
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_public/_landing/get-started')({
  component: () => null,
});
